/* plantas finas — Empfehlungskarten im Dashboard
   Ersetzt die Platzhalter-Kacheln ("Foto") durch echte Produktkarten mit
   Bild, Titel, Preis und Link. Die Daten liefert snippets/pf-dash-products.liquid
   über ein JSON-Script-Tag direkt aus Shopify.

   Läuft nach pf-dashboard.js und zeichnet #db-recs neu. Beobachtet zusätzlich
   Änderungen, weil pf-dashboard.js die Karten bei jeder Eingabe neu aufbaut. */
(function () {
  var DATA = {};
  try {
    var src = document.getElementById('pf-dash-products');
    if (src) {
      var raw = JSON.parse(src.textContent);
      Object.keys(raw).forEach(function (k) { if (raw[k]) { DATA[k] = raw[k]; } });
    }
  } catch (e) { return; }

  /* Zuordnung: Produktname aus pf-dashboard.js -> Schlüssel in DATA.
     pf-dashboard.js kennt die echten Produkte nicht, deshalb erkennen wir
     die Karten am Linkziel bzw. am angezeigten Namen. */
  var MAP = {
    'Magnesium-Komplex': 'mag',
    'Vitamin D3 + K2 Tropfen': 'd3k2',
    'Omega-3': 'o3',
    'Eisen + Vitamin C': 'eisen',
    'Ashwagandha': 'ashwa',
    'Kollagen': 'kollagen',
    'Holunder + Vitamin C + Zink': 'zink',
    'Multivitamin + Mineralstoffe': 'zink',
    'Mariendistel Komplex': 'darm'
  };

  var box = document.getElementById('db-recs');
  if (!box) return;

  var busy = false;

  function upgrade() {
    if (busy) return;
    busy = true;

    var karten = box.querySelectorAll('.db-rec');
    Array.prototype.forEach.call(karten, function (karte) {
      if (karte.getAttribute('data-pf-ok') === '1') return;

      var link = karte.querySelector('a');
      if (!link) return;
      var key = MAP[link.textContent.trim()];
      var prod = key ? DATA[key] : null;

      if (!prod) {
        /* Kein passendes Produkt im Shop — Karte entfernen statt
           mit Platzhalter stehen zu lassen. */
        karte.parentNode.removeChild(karte);
        return;
      }

      link.textContent = prod.n;
      link.setAttribute('href', prod.u);

      var preis = karte.querySelector('.pr');
      if (preis) { preis.textContent = prod.p || ''; }

      var thumb = karte.querySelector('.thumb');
      if (thumb && prod.img) {
        var bild = document.createElement('img');
        bild.className = 'thumb';
        bild.src = prod.img;
        bild.alt = prod.n;
        bild.loading = 'lazy';
        bild.width = 64;
        bild.height = 64;
        bild.style.objectFit = 'contain';
        bild.style.background = '#fff';
        thumb.parentNode.replaceChild(bild, thumb);
      }

      karte.setAttribute('data-pf-ok', '1');
    });

    /* Bleibt nach dem Aufräumen nichts übrig, einen Hinweis zeigen
       statt einer leeren Karte. */
    if (!box.querySelector('.db-rec') && !box.querySelector('.db-hint')) {
      var p = document.createElement('p');
      p.className = 'db-hint';
      p.textContent = 'Zu deiner Auswahl haben wir aktuell kein passendes Produkt im Sortiment.';
      box.appendChild(p);
    }

    busy = false;
  }

  upgrade();
  new MutationObserver(upgrade).observe(box, { childList: true, subtree: true });
})();
